import { SectionTemplateHeader } from "components/MainSectionTemplate/SectionTemplateHeader";
import { CustomSection } from "components/MainSectionTemplate/types";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import Table from "components/Tables/Table";
import React from "react";

interface Props {
  functionGroups: server.dto.FunctionGroup[]
}

const FunctionGroupsPanel = (props: Props) => {
  return <SectionPanel.Panel
    header={<SectionTemplateHeader>Function groups</SectionTemplateHeader>}
  >
    <Table
      items={props.functionGroups}
      isLoading={false}
      getKey={fg => fg.value.toString()}
      columns={[
        {
          key: "title",
          header: "",
          render: fg => <div>{fg.text}</div>
        }
      ]}
      hideHeader
    />
  </SectionPanel.Panel>
}

export const functionGroupsPanelSection = (functionGroups: server.dto.FunctionGroup[]): CustomSection => {
  return {
    key: "functionGroups",
    type: "custom",
    render: () => <FunctionGroupsPanel key="functionGroups" functionGroups={functionGroups} />
  } 
}